<template>
  <div id="footer" class="container-fluid">
    <div class="logo">
<!--      <img src="@/assets/img/logobet.png" alt="logo图">-->
    </div>
    <p class="title">{{ $t('footerMsg.companyName') }}</p>
    <p class="address_tel_fax">
      <span>{{ $t('footerMsg.address') }}</span>
      <span>Tel：18122098145</span>
<!--      <span>Fax：8888-88888888</span>-->
    </p>
    <p class="email_wx">
      <span>{{$t('footerMsg.emil')}}：yb_cert@163.com</span>
      <span>{{$t('footerMsg.companyWecat')}}：YiBo_cert</span>
    </p>
    <p class="copy">Copyright &copy; 2022 - 2026 {{ $t('footerMsg.companyName') }}</p>
  </div>
</template>
<script>
export default {
  name: "Footer",
  data() {
    return {};
  }
};
</script>
<style scoped>
#footer {
  width: 100%;
  height: 100%;
  color: #fff;
  background: #474747;
  overflow: hidden;
  text-align: center;
}
.logo {
  width: 95px;
  margin: 50px auto 20px;
}
.title {
  font-size: 25px;
  margin-bottom: 20px;
}
.address_tel_fax {
  color: #d3d3d3;
  font-size: 14px;
  margin: 10px 0;
}
.email_wx {
  color: #d3d3d3;
  font-size: 14px;
}
.copy {
  color: #d3d3d3;
  font-size: 14px;
  margin: 50px 0 10px;
}
@media screen and (max-width: 997px) {
  .title {
    font-size: 20px;
  }
  .address_tel_fax {
    font-size: 12px;
  }
  .email_wx {

  font-size: 12px;
}
.copy {
  font-size: 12px;
  margin: 30px 0 10px;
}
}
</style>




// WEBPACK FOOTER //
// src/components/Footer.vue